import { c as _c } from "react/compiler-runtime";
import UserPageRateWrapper from "@/components/user/utils/rate/UserPageRateWrapper";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
import { RateMatter } from "@/types/enums";
import UserPageIdentityHeaderCICRate from "./cic-rate/UserPageIdentityHeaderCICRate";
import UserPageIdentityHeaderCIC from "./UserPageIdentityHeaderCIC";
export default function UserPageIdentityHeader(t0) {
  const $ = _c(11);
  const {
    profile
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="tw-flex tw-flex-col"><h2 className="tw-mb-1 tw-text-xl tw-font-semibold tw-text-iron-100 sm:tw-text-2xl sm:tw-tracking-tight">Network Identity Check (NIC)</h2><p className="tw-mb-0 tw-text-sm tw-font-normal tw-text-iron-200 sm:tw-text-base">Does the network believe this profile accurately represents its identity?</p></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== profile) {
    t2 = <UserPageIdentityHeaderCIC profile={profile} />;
    $[1] = profile;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== profile) {
    t3 = <UserPageIdentityHeaderCICRate profile={profile} isTooltip={false} />;
    $[3] = profile;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== profile || $[6] !== t3) {
    t4 = <UserPageRateWrapper profile={profile} type={RateMatter.NIC}>{t3}</UserPageRateWrapper>;
    $[5] = profile;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t2 || $[9] !== t4) {
    t5 = <div><div className="tw-lg:justify-between tw-mt-6 lg:tw-mt-8 lg:tw-flex lg:tw-items-center"><div className="tw-min-w-0 tw-flex-1">{t1}{t2}{t4}</div></div></div>;
    $[8] = t2;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}